<template>
  <div>
    <div id="menu-popup">
      <div id="main-wrapper">
        <div id="wshatIsHere-frame">
          <!-- menu and category header -->
          <ul class="tabs" v-if="shouldShowTabsHeader">
            <!-- <ul class="tabs" v-if="headerVisible && !$root.$data.embedded && categoryFrames.length > 0 && isFromWhatIsHere "> -->
            <li
              v-for="frame in categoryFrames"
              :key="frame"
              :class="{active: currentComponent === frame}"
              @click="updateFrame(frame)"
            >
              {{ $t("menuPopup." + frame) }}
            </li>
            <li class="tabs-close" @click.stop="goToCategories">
              <button>
                <img src="../../assets/icons/close1.png" alt="" />
              </button>
            </li>
          </ul>
        </div>
        <keep-alive v-if="!showRoutingMap">
          <component :is="currentTabComponent" @showHeader="showHeader" />
        </keep-alive>

        <!-- <Map3DMTK
          ref="map3d"
          v-if="!showRoutingMap"
          :lat="initialLat"
          :lng="initialLng"
          :zoom="initialZoom"
          :start="start"
          :end="end"
          :mode="currentRouteType"
          :triggerCalculation="triggerCalculation"
          :route="routeCoords"
        /> -->
        <RoutingMTK
          v-if="!showRoutingMap"
          :start="start"
          :end="end"
          :mode="currentRouteType"
          :calculate="triggerCalculation"
          :selecting="selecting"
          @startSelected="start = $event"
          @endSelected="end = $event"
          @routeCalculated="onRouteCalculated"
          @routeReset="handleRouteReset"
        />
        <div class="bottom-buttons" v-if="!showRoutingMap && currentComponent !== 'streets'">
          <!-- <div class="bottom-buttons" v-if="!showRoutingMap"> -->
          <button class="routing-button" @click="openDirectionFrame" :title="$t('buttons.routing')">
            <img
              src="@/assets/icons/delivery_24x24.png"
              alt="Routing Icon"
              style="height: 24px; width: 24px; margin-right: 8px"
            />
            {{ $t("buttons.routing") }}
          </button>

          <button v-if="withStreets" class="streets-button" @click="openStreetsFrame" :title="$t('buttons.streets')">
            <img
              src="@/assets/icons/streets.png"
              alt="Routing Icon"
              style="height: 24px; width: 24px; margin-right: 8px"
            />
            {{ $t("buttons.streets") }}
          </button>
        </div>

        <!-- <div class="routing-wrapper" v-if="!showRoutingMap">
          <button class="routing-button" @click="openDirectionFrame" :title="$t('buttons.routing')">
            <img
              src="@/assets/icons/delivery_24x24.png"
              alt="Routing Icon"
              style="height: 24px; width: 24px; margin-right: 8px"
            />
            {{ $t("buttons.routing") }}
          </button>
        </div> -->
      </div>
    </div>
    <div id="routing-map-wrapper">
      <MapRoutingMTK
        ref="routing"
        v-if="showRoutingMap"
        :initialLat="initialLat"
        :initialLng="initialLng"
        :initialZoom="initialZoom"
        :start="start"
        :end="end"
        :mode="currentRouteType"
        :triggerCalculation="triggerCalculation"
        @close="handleCloseRouting"
        @mapClicked="handleMapClick"
        @routeCalculated="onRouteCalculated"
      />
    </div>
  </div>
</template>

<script>
import MapRoutingMTK from "@/components/MapRoutingMTK.vue";
import SettingButtonsComponent from "@/components/button_controls/SettingButtons.vue";
import CategoriesFrame from "./CategoriesFrame.vue";
import StreetDirectoryFrame from "./StreetDirectoryFrame.vue";
import RoutingMTK from "@/components/RoutingMTK.vue";
import Vue from "vue";

export default {
  name: "MenuPopup",
  components: {
    CategoriesFrame,
    StreetDirectoryFrame,
    RoutingMTK,
    SettingButtonsComponent,
    MapRoutingMTK
  },
  props: {
    initialLat: Number,
    initialLng: Number,
    initialZoom: Number,
    routingStart: Array,
    routingEnd: Array,
    routingMode: String
  },
  data() {
    return {
      currentComponent: "pois",
      headerVisible: true,
      showRoutingMap: false,
      routeCoords: null,
      start: null,
      end: null,
      selecting: "start",
      currentRouteType: "foot",
      distanceText: null,
      durationText: null,
      triggerCalculation: 0
    };
  },
  createdd() {
    const view = this.$route.params.view;
    const hasTocId = this.$route?.query?.["toc-id"] != null && String(this.$route.query["toc-id"]).trim() !== "";

    if (view && this.categoryFrames.includes(view)) {
      this.currentComponent = view;
    } else if (this.$route.query.wh === "1" || hasTocId) {
      this.currentComponent = "streets";
    }
  },
  created() {
    const view = this.$route.params.view;
    if (view && this.categoryFrames.includes(view)) {
      this.currentComponent = view;
    } else if (this.$route.query.wh === "1") {
      this.currentComponent = "streets";
    }
  },
  computed: {
    currentTabComponent() {
      return this.currentComponent === "streets" && Vue.config.project.with_streets
        ? "StreetDirectoryFrame"
        : "CategoriesFrame";
    },
    categoryFrames() {
      return Vue.config.project.with_streets ? ["streets"] : [];
    },
    isFromWhatIsHere() {
      return this.$route.query.wh === "1";
    },
    withStreets() {
      return Vue.config.project.with_streets;
    },
    hasTocId() {
      const v = this.$route?.query?.["toc-id"];
      return v != null && String(v).trim() !== "";
    },
    shouldShowTabsHeader() {
      return this.headerVisible && !this.$root.$data.embedded && this.currentComponent === "streets";
    }
  },
  watch: {
    "$route.query['toc-id']"(newVal) {
      const hasTocId = newVal != null && String(newVal).trim() !== "";
      if (hasTocId) {
        this.currentComponent = "streets";
        this.showRoutingMap = false;
      }
    },
    "$route.path": {
      immediate: true,
      handler(path) {
        if (path.includes("streets")) {
          this.currentComponent = "streets";
        } else {
          this.currentComponent = "pois";
          this.showRoutingMap = false;
          this.headerVisible = true;
        }
      }
    },
    // "$route.params.view"(view) {
    //   if (view && this.categoryFrames.includes(view)) {
    //     this.currentComponent = view;
    //     this.showRoutingMap = false;
    //   }

    // const hasWh = this.$route.query.wh === "1";
    // const tocId = this.$route?.query?.["toc-id"];
    // const hasToc = tocId != null && String(tocId).trim() !== "";

    // if (!hasWh && !hasToc) {
    //   this.currentComponent = "pois";
    //   this.showRoutingMap = false;
    //   this.headerVisible = true; // opțional, ca să nu rămână ascuns
    // }
    // },
    currentRouteType(newVal) {
      if (this.start && this.end) {
        console.log("Recalculating route for mode: MenuPopup", newVal);
        this.triggerCalculation++;
      } else {
        console.warn("No coordinates available for recalculation");
      }
    },
    initialLat: "logCoordonateComplete",
    initialLng: "logCoordonateComplete",
    initialZoom: "logCoordonateComplete"
  },
  mounted() {
    this._openRoutingHandler = e => this.openDirectionFrame(e.detail || {});
    window.addEventListener("openRoutingMapMTK", this._openRoutingHandler);
  },
  beforeDestroy() {
    window.removeEventListener("openRoutingMapMTK", this._openRoutingHandler);
  },

  methods: {
    openStreetsFrame() {
      this.currentComponent = "streets";
      this.showRoutingMap = false;

      // IMPORTANT: reset header
      this.headerVisible = true;

      const q = {...this.$route.query, wh: "1"};

      this.$router
        .push({
          name: this.$route.name,
          params: {...this.$route.params, view: "streets"},
          query: q
        })
        .catch(err => {
          if (err && err.name !== "NavigationDuplicated") console.error(err);
        });
    },
    goToCategories() {
      this.currentComponent = "pois";
      this.showRoutingMap = false;

      const q = {...this.$route.query};
      delete q.wh;
      delete q.str_id;
      delete q.hnr;

      this.$router
        .push({
          name: this.$route.name,
          params: {...this.$route.params, view: "pois"},
          query: q
        })
        .catch(err => {
          if (err && err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
    },
    logCoordonateComplete() {
      if (this.initialLat && this.initialLng && this.initialZoom) {
        console.log("Coordonates set:", this.initialLat, this.initialLng, this.initialZoom);
      }
    },

    updateFrame(frame) {
      this.currentComponent = frame;
      this.showRoutingMap = false;
    },
    showHeader(visible) {
      if (this.currentComponent === "streets") {
        this.headerVisible = true;
        return;
      }
      this.headerVisible = visible;
    },
    openDirectionFrame(payload = null) {
      const global = this.$root.$data;
      this.$root.$emit("routingStatus", {isRoutingActive: true});

      const norm = s => {
        if (!s) return null;
        if (Array.isArray(s) && s.length >= 2) return {lat: Number(s[0]), lng: Number(s[1])};
        if (typeof s === "object") {
          if (typeof s.lat === "number" && typeof s.lng === "number") return {lat: s.lat, lng: s.lng};
          if (typeof s.lat === "number" && typeof s.lon === "number") return {lat: s.lat, lng: s.lon};
        }
        return null;
      };

      const startFromPayload = norm(payload?.start);
      const modeFromPayload = payload?.mode;

      this.start = startFromPayload;
      this.end = null;
      this.selecting = "end";

      this.currentRouteType = modeFromPayload || global.routingMode || "car";

      const pos = startFromPayload || global.globalRoutingPosition || null;
      if (pos?.lat && pos?.lng) {
        this.initialLat = pos.lat;
        this.initialLng = pos.lng;
        this.initialZoom = pos.zoom ?? 16;
      } else {
        this.initialLat = 45.1;
        this.initialLng = 28.8;
        this.initialZoom = 10;
      }

      this.routeCoords = null;
      this.distanceText = null;
      this.durationText = null;

      this.showRoutingMap = true;
      this.$root.$emit("routingStatus", {isRoutingActive: true});
    },
    handleRoute({coords, summary}) {
      console.log("Route calculated:", coords, summary);
      this.routeCoords = coords;
      this.distanceText = (summary.distance / 1000).toFixed(2) + " km";

      const hours = Math.floor(summary.duration / 3600);
      const minutes = Math.round((summary.duration % 3600) / 60);
      this.durationText = `${hours > 0 ? hours + "h " : ""}${minutes}min`;

      this.$emit("routingStatus", {
        isRoutingActive: true,
        isRouting3DActive: false
      });
    },
    onRouteCalculated(data) {
      this.handleRoute(data);
    },

    handleRouteReset() {
      console.log("Route reset");
      this.routeCoords = null;
      this.distanceText = null;
      this.durationText = null;
    },
    handleCloseRouting() {
      this.showRoutingMap = false;
      this.start = null;
      this.end = null;
      this.routeCoords = null;
      this.distanceText = null;
      this.durationText = null;
      this.triggerCalculation++;
      this.$root.$emit("routingStatus", {isRoutingActive: false});
      const tocId = this.$route?.query?.["toc-id"];
      const hasToc = tocId != null && String(tocId).trim() !== "";
      this.$root.$emit("openCategoriesMenu", {withOverlay: hasToc});
    },
    handleStartSelected(coords) {
      console.log("Start selected:", coords);
      this.start = coords;
      this.selecting = "end";
    },
    handleEndSelected(coords) {
      console.log("End selected::", coords);
      this.end = coords;
      this.triggerCalculation++;
    },

    handleMapClick({type, coords}) {
      if (this.$refs.routing?.handleMapClickFromMap) {
        this.$refs.routing.handleMapClickFromMap(type, coords);
      } else {
        console.warn("Invalid ref to mapRouting");
      }
    }
  }
};
</script>
<style scoped>
.tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
}

.tabs li {
  /* width: 9% !important; */
  list-style: none;
  display: flex;
  align-items: center;
  padding-left: 8px;
}

.tabs-close {
  width: 11% !important;
  /* margin-left: auto; */
}

.tabs-close button {
  width: 20%;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.tabs-close img {
  width: 20px;
  height: 20px;
  opacity: 0.7;
}

.tabs-close img:hover {
  opacity: 1;
}
</style>
<style scoped lang="scss">
@import "@/assets/css/base";

#lhs_wrapper {
  position: relative;
  z-index: 10010;
}

// @media (max-height: 700px) {
//   #lhs_wrapper {
//     max-height: 75vh;
//     overflow-y: auto;
//   }
// }

.tabs-close {
  position: relative;
}

#routing-map-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  pointer-events: none;
  display: block;
}

@include mobile {
  #routing-map-wrapper {
    z-index: 2;
    // display: block;
    pointer-events: none;
  }
}

.map-container {
  width: 100%;
  height: 100%;
  pointer-events: auto;
}

.maplibregl-map {
  z-index: 1 !important;
}
#main-wrapper {
  position: relative;
}

.bottom-buttons {
  // position: absolute;
  bottom: calc(12px + env(safe-area-inset-bottom));
  left: 12px;
  right: 12px;
  display: flex;
  gap: 12px;
}

.routing-button,
.streets-button {
  margin-top: 5px;
  font-family: Quicksand, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3em;
  letter-spacing: 0.03em;
  color: #464646;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #ecf0f3;
  box-shadow: 2px 4px 4px #999999;
  border: 1px solid #a9a99a;
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease;

  i {
    font-size: 22px;
  }

  &:hover {
    background-color: #f0f0f0;
  }

  cursor: pointer;
  font-weight: 600;
}

// .routing-button:active,
// .streets-button:active {
//   transform: scale(0.99);
// }
</style>
